import { useState, useEffect, useContext } from "react";
import { Typography, Button, Form, Image, Spin, Divider } from "antd";
import TspService from "../../../services/crud/TspService";
import { OverlayContext } from "../../../context/OverlayContext";
import { ToastContext } from "../../../context/ToastContext";
import { ArrowLeftOutlined, LoadingOutlined } from "@ant-design/icons";
import Tsp from "../../../models/Tsp";
import { UploadFileForm } from "../../../components/forms/UploadFileForm";
import TspVoucherService from "../../../services/crud/TspVoucherService";
import { tspKeyEnum } from "../../../models/tspKeyEnum";
import { useNavigate, useParams } from "react-router-dom";
import KintoService from "../../../services/crud/KintoService";
import { downloadFile } from "../../../helpers/download-file";
import DownloadBillingDataForm from "../../../components/forms/DownloadBillingDataForm";
import { dateEndOfLocalDay, dateStartOfLocalDay, formatDate } from "../../../utils/dates";

const Header = () => {
  let navigate = useNavigate();
  const gotoPage = (route) => {
    console.log("route is: " + route);
    navigate(route);
  };
  return (
    <div>
      <Button size="small" icon={<ArrowLeftOutlined />} type="link" onClick={() => gotoPage(-1)}>
        Back TSP list
      </Button>
    </div>
  );
};

function TspView() {
  const { id } = useParams<any>();
  const { openModal, closeModal } = useContext(OverlayContext);
  const { loading, loadMessage } = useContext(ToastContext);
  const [form] = Form.useForm();
  const [tsp, setTsp] = useState<Tsp>(null);

  useEffect(() => {
    loadMessage("Loading Tsps...", () =>
      TspService.getTsp(id).then((tsp) => {
        setTsp(tsp);
      })
    );
  }, [id]);

  const openUploadFileModal = (fileKind: string, uploadMessage: string, upload: Function) => {
    let file = null;
    const onSelectFile = (f) => { file = f };
    form.resetFields();
    openModal({
      title: `Upload ${fileKind}`,
      content: <UploadFileForm form={form} accept=".xlsx,.xls" onSelectFile={onSelectFile} />,
      okText: 'Upload',
      onOk: () => {
        closeModal();
        form.validateFields().then(async (values) => {
          console.log(file);
          upload(file);
        })
      },
    });
  };

  const showResult = (title: string, body: string) => {
    openModal({
      title: title,
      content: (<p>{body}</p>),
      okText: 'Close',
      hasCancel: false,
    });
  }

  const openUploadVoucherCodesModal = () => {
    openUploadFileModal('voucher codes Excel file', 'Uploading Voucher Codes...', async (file) => {
      TspVoucherService.uploadVoucherCodes(tsp.tspKey as tspKeyEnum, file).then((result) => {
        if (result) {
          showResult("Success", "Voucher codes has been added. Verify by looking in database and/or EC2B app.");
          return;
        }
        showResult("Error", "Failed to upload voucher codes");
      }).catch(res => {
        console.log(res);
        showResult("Error", "Failed to upload voucher codes");
      });
    })
  };
  const openUploadDriveDataModal = () => {
    openUploadFileModal('KINTO drive data Excel file', 'Uploading Drive Data...', async (file) => {
      KintoService.uploadDriveData(file).then((result) => {
        if (result) {
          showResult("Success", "Drive data has been uploaded");
          return;
        }
        showResult("Error", "Failed to upload drive data");
      }).catch(res => {
        console.log(res);
        showResult("Error", "Failed to upload drive data. ");
      });
    })
  };
  const openDownloadBillingDataModal = () => {
    form.resetFields();
    openModal({
      title: 'Voucher billing data',
      content: <DownloadBillingDataForm form={form} />,
      okText: 'Download',
      onOk: () => {
        closeModal();
        form.validateFields().then(async (values) => {
          let [startDate, endDate] = values.dates;
          startDate = dateStartOfLocalDay(startDate);
          console.log(endDate);
          endDate = dateEndOfLocalDay(endDate);
          console.log(endDate);
          const blob = await TspVoucherService.downloadBillingData(tsp.tspKey, startDate, endDate);
          await downloadFile(blob, `Billing data ${formatDate(startDate)} - ${formatDate(endDate)}.xlsx`);
        })
      },
    });
  };

  if (loading || tsp === null) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />}>
        <></>
      </Spin>
    )
  }

  return (
    <div>
      <Header></Header>
      <div>
      </div>
      <Typography.Title level={1} style={{ marginTop: "15px" }}>
        <Image src={tsp?.logo} style={{ width: 'auto', height: 60, objectFit: 'contain'  }} alt={tsp?.name} />
      </Typography.Title>
      {[
        tspKeyEnum.KINTO_SHARE as string,
        tspKeyEnum.CORIDE as string,
      ].indexOf(tsp?.tspKey) !== -1 && (
        <div>
          <Divider />
          <Button onClick={openUploadVoucherCodesModal}>Upload Voucher Codes</Button>
          <Button onClick={openUploadDriveDataModal}>Upload Drive data</Button>
          <Button onClick={openDownloadBillingDataModal}>Download billing data</Button>
        </div>
      )}
      <div style={{height: 30}} />
    </div>
  );
}

export default TspView;
